module.exports = __webpack_public_path__ + "img/Жетісу облысы.aaf449a0.png";